/** * @author Pawan Sadvale * @email Pawan.Sadvale@ul.com * @create date 2020-01-17 21:17:50 *
@modify date 2020-01-17 21:17:50 * @desc */
<template>
  <div class="responsive_wrapper" :id="updateId">
    <div v-if="permissions.includes('REGULATORY_UPDATE_SETTINGS')">
      <div class="note_text">
        <span
          >Indicate how often you'd like to receive regulatory updates and for which countries. To
          limit the regulatory updates displayed within the application to just the designated
          countries, select "Sync Display". Otherwise, updates for all countries will be available
          within the Regulatory Updates page.</span
        >
      </div>
      <div class="mr-tb-15">
        <div class="row_wrapper row">
          <div class="col-md-6 col-sm-6 col-xs-12 header_label_text">Type</div>
          <div class="col-md-3 col-sm-3 hide_xs in_app_label header_label_text">Sync Display</div>
          <div class="col-md-3 col-sm-3 hide_xs">
            <span class="ml-15 header_label_text">
              Email
              <el-popover
                placement="bottom-end"
                trigger="click"
                class="main_popover"
                @show="infoActive = true"
                @hide="infoActive = false"
              >
                <div>
                  <div class="mr-bt-10">
                    <span class="tooltip_sub_content_heading">Never:</span> No emails will be sent
                  </div>
                  <div class="mr-bt-10">
                    <span class="tooltip_sub_content_heading">Every Alert:</span> Emails will be
                    sent immediately and for every triggered notification
                  </div>
                  <div class="mr-bt-10">
                    <span class="tooltip_sub_content_heading">Daily summary:</span> A daily summary
                    of the triggered notification type will be sent
                  </div>
                  <div class="mr-bt-10">
                    <span class="tooltip_sub_content_heading">Weekly summary:</span> A weekly
                    summary of the triggered notification type will be sent
                  </div>
                </div>
                <!-- <template #reference> -->
                <img
                  class="info-img"
                  src="/static/images/icons/info_icon.svg"
                  v-if="!infoActive"
                  alt="info-icon"
                  slot="reference"
                />
                <img
                  class="info-img"
                  src="/static/images/icons/info_icon_active.svg"
                  v-if="infoActive"
                  alt="infoactive-icon"
                  slot="reference"
                />
                <!-- </template> -->
              </el-popover>
            </span>
          </div>
        </div>
        <div class="row_wrapper row">
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="alert_text">Regulatory changes occur</label>
          </div>
          <div class="toggle_switch col-md-3 col-sm-3 col-xs-6">
            <small class="display_xs">Sync Display</small>
            <div v-if="permissions.includes('REG_WTCH_RUPD_SETT_EDIT_SYNC_DISPLAY')">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="regulatory_sync_display"
                  @change="$emit('update:sync_display', $event.target.checked)"
                />
                <span class="slider round"></span>
              </label>
              <span v-if="regulatory_sync_display" class="switch_label">On</span>
              <span v-else class="switch_label switch_off">Off</span>
            </div>
          </div>
          <div class="col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5">
            <small class="display_xs ml-20">Email</small>
            <multiselect
              v-if="permissions.includes('REG_WTCH_RUPD_SETT_EDIT_EMAIL')"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              open-direction="bottom"
              :searchable="false"
              :options="frequency_options.map((frequency) => frequency.value)"
              :custom-label="(option) => frequency_options.find((x) => x.value === option).label"
              v-model="emailFrequency"
              placeholder="Select"
            >
            </multiselect>
          </div>
        </div>
      </div>
      <div class="col-sm-12 pl-0 pr-0">
        <div class="col-sm-7 col-xs-12 pl-0 mr-tb-15 alert_text">
          Show regulatory change updates for:
        </div>
        <div class="col-sm-5 col-xs-12 search-country">
          <search-box v-model="searchRegWatch" @getList="searchCountries"></search-box>
        </div>
      </div>
      <div
        class="col-sm-12 container1"
        v-if="permissions.includes('REG_WTCH_RUPD_SETT_SHOW_REGULATORY_UPDATES')"
      >
        <div class="section">
          <div class="scrollable-content content">
            <div class="desc_text" style="display: none">
              <span class="checkbox">
                <label>
                <input
                  type="checkbox"
                  v-model="selectAll"
                  :disabled="disableAllCheckbox"
                /><span class="cr"></span>
              </label>
                </span>
              <span class="cust_label all_market_label">All Market Regions</span>
            </div>
            <template v-for="(region, index) in regions">
              <div :key="index" v-if="index !== 'Global (non-market specific)'" class="desc_text">
                <div class="country_label_container">
                  <span class="checkbox mr-12" style="visibility: hidden">
                    <label>
                      <input
                        type="checkbox"
                        class="form-control"
                        @change="regionEvent(index)"
                        v-model="regionsMultiselect"
                        :disabled="disableAllCheckbox"
                      />
                      <span class="cr"></span>
                    </label>
                  </span>
                  <div
                    class="cursor-pointer flex_grow_1"
                    data-toggle="collapse"
                    :data-target="'#' + index.replace(/\s/g, '') + '_collapse'"
                    :class="index.replace(/\s/g, '')"
                  >
                    <span v-if="index == 'Unknown'">Others</span>
                    <span v-else>{{ index }}</span>
                    <span class="collapse_arrow fa fa-angle-down"></span>
                  </div>
                </div>
                <div :id="index.replace(/\s/g, '') + '_collapse'" class="collapse ml-30">
                  <div
                    class="desc_text"
                    v-for="(country, indexcountry) in region"
                    :key="indexcountry"
                  >
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="Default country cannot be unselected"
                      placement="top-start"
                      :disabled="disableAllCheckbox || !country[2]"
                    >
                      <span class="checkbox inline-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            class="form-control"
                            v-model="reg_notif_country_ids"
                            :value="country[0]"
                            @change="countryEvent(index, country[0])"
                            :disabled="disableAllCheckbox || country[2]"
                          />
                          <span class="cr"></span>
                        </label>
                      </span>
                    </el-tooltip>
                    <span class="cust_label">{{ country[1] }}</span>
                  </div>
                </div>
              </div>
            </template>
            <div
              v-for="(country, indexs) in regions['Global (non-market specific)']"
              :key="indexs"
              class="other-regions pb-8 pt-8"
            >
              <el-tooltip
                class="item"
                effect="light"
                content="Default country cannot be unselected"
                placement="top-start"
                :disabled="disableAllCheckbox || !country[2]"
              >
                <span class="checkbox inline-checkbox">
                  <label>
                      <input
                        type="checkbox"
                        class="form-control"
                        v-model="reg_notif_country_ids"
                        :value="country[0]"
                        @change="countryEvent('Global (non-market specific)', country[0])"
                        :disabled="disableAllCheckbox || country[2]"
                      /><span class="cr"></span>
                  </label>
                </span>
              </el-tooltip>
              <span class="cust_label">{{ country[1] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="col-xs-8 notification_box row">
      You currently do not have permissions to access this section, please contact your Admin.
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import { Popover, Tooltip } from 'element-ui';
import SearchBox from '../UIComponents/SearchBox.vue';
import { getRegWatchCountries } from '../../apis/countriesList';
// import BaseTooltip from '../Common/BaseTooltip.vue';
// import BasePopover from '../Common/BasePopover.vue';

export default {
  components: {
    // BaseTooltip,
    // BasePopover,
    SearchBox,
    'el-popover': Popover,
    'el-tooltip': Tooltip
  },
  props: [
    'permissions',
    'account_id',
    'frequency_options',
    'sync_display',
    'email_frequency',
    'regulatory_email_notification_country_ids',
    'default_country'
  ],
  data() {
    return {
      updateId: 1,
      searchRegWatch: '',
      regionsCopy: '',
      countries: [],
      regions: {},
      reg_notif_country_ids: [],
      regionsIds: [],
      regionsMultiselect: [],
      emailFrequency: '',
      infoActive: false,
      regulatory_sync_display: false
    };
  },
  watch: {
    email_frequency() {
      this.emailFrequency = this.email_frequency;
    },
    regulatory_email_notification_country_ids() {
      this.validateNSelectCountriIds();
      this.validateRegions();
    },
    sync_display() {
      this.regulatory_sync_display = this.sync_display;
    }
  },
  async created() {
    this.$emit('loaderStatus', true);
    await this.getAllRegions();
    this.sortRegionWise();
    this.emailFrequency = this.email_frequency;
    this.validateNSelectCountriIds();
    this.validateRegions();
  },
  computed: {
    disableAllCheckbox() {
      if (this.emailFrequency === 'never' || !this.emailFrequency) {
        if (!this.regulatory_sync_display) {
          return true;
        }
      }
      return false;
    },
    selectAll: {
      get() {
        return this.countries ? this.reg_notif_country_ids.length === this.countries.length : false;
      },
      set(value) {
        const selected = [];
        let keys = [];
        if (value) {
          this.countries.forEach((country) => {
            selected.push(parseInt(country.id, 10));
          });
          keys = Object.keys(this.regions);
        }
        this.regionsMultiselect = keys;
        this.reg_notif_country_ids = selected;
      }
    }
  },
  methods: {
    searchCountries() {
      const regionsList = Object.keys(this.regionsCopy);
      this.updateId += 1;
      if (this.searchRegWatch.length >= 2) {
        this.regions = { ...this.regionsCopy };
        for (let i = 0; i < regionsList.length; i += 1) {
          this.regions[regionsList[i]] = this.regions[regionsList[i]].filter((countryList) =>
            countryList[1].toLowerCase().includes(this.searchRegWatch.toLowerCase())
          );
          if (this.regions[regionsList[i]].length) {
            // Non market also can be searched && it is not in collapse so exclude non market specific
            if (regionsList[i] !== 'Global (non-market specific)') {
              const regionName = `#${regionsList[i].replace(/\s/g, '')}_collapse`;
              if (!$(regionName)[0].classList.value.includes('in')) {
                $(`.flex_grow_1.${regionsList[i].replace(/\s/g, '')}`).click();
              }
            }
          } else {
            delete this.regions[regionsList[i]];
          }
        }
      } else {
        this.regions = { ...this.regionsCopy };
        for (let i = 0; i < regionsList.length; i += 1) {
          const regionName = `#${regionsList[i].replace(/\s/g, '')}_collapse`;
          const documentRegionName = `${regionsList[i].replace(/\s/g, '')}_collapse`;
          if (
            document.getElementById(documentRegionName) != null &&
            regionName !== '#Non-MarketSpecific_collapse' &&
            document.getElementById(documentRegionName).className.includes('in')
          ) {
            $(`.flex_grow_1.${regionsList[i].replace(/\s/g, '')}`).click();
          }
        }
      }
    },
    validateNSelectCountriIds() {
      let Ids = [];
      if (this.regulatory_email_notification_country_ids.length) {
        if (this.regulatory_email_notification_country_ids[0] === 'all') {
          Ids = this.getAllIds();
        } else {
          Ids = [];
          _.forIn(this.regulatory_email_notification_country_ids, (id) => {
            if (id) Ids.push(parseInt(id, 10));
          });
        }
      }
      if (this.default_country && !Ids.includes(this.default_country))
        Ids.push(this.default_country);
      this.reg_notif_country_ids = Ids;
    },
    getAllIds() {
      const IDs = [];
      this.countries.forEach((country) => {
        IDs.push(parseInt(country.id, 10));
      });
      return IDs;
    },
    validateRegions() {
      let count = 0;
      const that = this;
      _.forIn(this.regionsIds, (ids, region) => {
        count = 0;
        _.forIn(ids, (id) => {
          if (that.reg_notif_country_ids.indexOf(id) !== -1) {
            count += 1;
          }
        });
        that.validateRegionAllIds(region, count);
      });
    },
    countryEvent(checkedRegion, value) {
      let count = 0;
      let index = '';
      if (this.reg_notif_country_ids.indexOf(value) !== -1) {
        for (let i = 0; i < this.regionsIds[checkedRegion].length; i += 1) {
          index = this.reg_notif_country_ids.indexOf(this.regionsIds[checkedRegion][i]);
          if (index !== -1) {
            count += 1;
          } else {
            break;
          }
        }
        if (count === this.regionsIds[checkedRegion].length) {
          this.regionsMultiselect.push(checkedRegion);
        }
      } else {
        this.validateNDisSelectRegion(checkedRegion);
      }
    },
    validateRegionAllIds(region, count) {
      if (count === this.regionsIds[region].length) {
        if (this.regionsMultiselect.indexOf(region) === -1) this.regionsMultiselect.push(region);
      } else {
        this.validateNDisSelectRegion(region);
      }
    },
    validateNDisSelectRegion(region) {
      const index = this.regionsMultiselect.indexOf(region);
      if (index !== -1) {
        this.regionsMultiselect.splice(index, 1);
      }
    },
    regionEvent(key) {
      let index = '';
      if (this.regionsMultiselect.indexOf(key) !== -1) {
        for (let i = 0; i < this.regionsIds[key].length; i += 1) {
          if (this.reg_notif_country_ids.includes(this.regionsIds[key][i]) === false)
            this.reg_notif_country_ids.push(this.regionsIds[key][i]);
        }
      } else {
        for (let i = 0; i < this.regionsIds[key].length; i += 1) {
          index = this.reg_notif_country_ids.indexOf(this.regionsIds[key][i]);
          if (index !== -1) {
            this.reg_notif_country_ids.splice(index, 1);
          }
        }
      }
    },
    sortRegionWise() {
      this.countries.forEach((country) => {
        const countryId = parseInt(country.id, 10);
        const countryName = country.country_name.toString();
        let isDefault = false;
        if (countryName === 'Global (non-market specific)') isDefault = true;
        if (typeof this.regions[country.region] === 'undefined') {
          this.regions[country.region] = [];
          this.regionsIds[country.region] = [];
        }
        this.regions[country.region].push([countryId, countryName, isDefault]);
        this.regionsIds[country.region].push(countryId);
      });
      this.regionsCopy = { ...this.regions };
    },
    async getAllRegions() {
      const countries = await getRegWatchCountries();
      this.countries = countries.sort((a, b) => {
        if (a.region > b.region) return 1;
        if (b.region > a.region) return -1;
        return 0;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container1 {
  max-height: calc(81vh - 405px);
  margin: 0px 0px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.responsive_wrapper {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}
.collapse {
  div {
    &.desc_text {
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
}
.ptb-5 {
  padding: 5px 0;
}
div[aria-expanded='true'] {
  .collapse_arrow {
    -webkit-transform: rotate(180deg); /* to support Safari and Android browser */
    -ms-transform: rotate(180deg); /* to support IE 9 */
    transform: rotate(180deg);
  }
}
.collapse_arrow {
  float: right;
  vertical-align: middle;
  font-size: 18px;
}
.ml-18 {
  margin-left: 18px;
}
.country_label_container {
  display: flex;
  align-items: center;
  padding: 0px 10px 0px 0px;
}
.flex_grow_0 {
  flex-grow: 0;
}
.flex_grow_1 {
  flex-grow: 1;
}
.switch {
  margin-left: 0;
}

.info-img {
  width: 20px;
  vertical-align: top;
  margin-left: 4px;
  margin-top: 1px;
}
.note_text {
  margin-top: 15px;
  margin-bottom: 15px;
  font-family: Roboto;
  font-style: normal;
  @include fontItems($font-14, 16px, $font-weight-normal !important);
  color: $dark-black-alpha;
}
.all_market_label {
  font-weight: $font-weight-medium;
  color: $primary;
}
.cust_label {
  font-size: $font-14;
}
.cust_checkbox {
  margin-left: 3px;
  display: inline-block;
}
.mr-tb-15 {
  margin: 15px 0px !important;
}

.header_text {
  padding-bottom: 0;
  padding-top: 0;
  border-bottom: 0.5px solid $gray74;
}
.desc_text {
  font-size: $font-14;
  padding-bottom: 16px;
  padding-top: 16px;
  border-bottom: 0.5px solid $gray74;
}
.radio label {
  cursor: none;
}
.ml-15 {
  margin-left: 15px;
}
.header_label_text {
  @include fontItems($font-16, 19px, $font-weight-medium);
  color: $dark-black-alpha;
}
.alert_text {
  font-family: Roboto;
  font-style: normal;
  @include fontItems($font-14, 16px, $font-weight-normal !important);
  vertical-align: bottom;
  color: $dark-black-alpha !important;
  margin-bottom: 0px;
}
.row_wrapper {
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 0.5px solid $gray74;
}
.display_xs {
  display: none;
}
.notification_box {
  color: $dark-black-alpha;
  position: fixed;
  top: 52%;
  left: 54%;
  background: #f2f2f2;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: $radius10;
  transform: translate(-40%, -50%);
  text-align: center;
  margin: 0 auto;
  padding: 20px 0px 20px 0px;
}
::v-deep .main_popover {
  .popover {
    &.bottom {
      left: -225px !important;
      border: none;
      .arrow {
        opacity: 1;
        left: 313px !important;
      }
    }
  }
}

.xs-mr-tp-5 {
  position: relative;
  left: 16px;
  width: 23%;
}
.search-country {
  padding-right: 0px;
}

.multiselect-single-dropdown {
  ::v-deep .multiselect__content-wrapper {
    max-height: 150px !important;
  }
}
@media screen and (max-width: 767px) {
  .switch {
    margin-left: 0px !important;
  }
  .hide_xs {
    display: none;
  }
  .xs-mr-tp-5 {
    margin-top: 5px;
  }
  .display_xs {
    display: block !important;
  }
  .cust_label {
    margin-left: 10px !important;
  }
}
@media screen and (max-width: 360px) {
  .responsive_wrapper {
    height: 53vh;
  }
}
@media (width: 1024px) and (height: 768px) {
  .responsive_wrapper {
    height: 35vh !important;
  }
}
@media screen and (width: 768px) {
  .container1 {
    max-height: 22vh !important;
  }
  .responsive_wrapper {
    height: unset !important;
  }
  .xs-mr-tp-5 {
    position: relative;
    left: 15px;
    width: 22%;
  }
}
@media (width: 1024px) and (min-height: 769px) {
  .container1 {
    max-height: 32vh !important;
  }
  .responsive_wrapper {
    height: 48vh !important;
  }
}
@media (min-width: 321px) and (max-width: 767px) {
  .container1 {
    max-height: 18vh;
  }
  .responsive_wrapper {
    height: 58vh;
  }
  .search-country {
    padding-left: 0px;
  }
  .xs-mr-tp-5 {
    position: relative;
    left: unset;
    width: 45%;
    ::v-deep {
      .multiselect.multiselect-single-dropdown {
        margin-left: 20px;
      }
    }
  }
}
@media screen and (max-width: 320px) {
  .container1 {
    max-height: 35vh;
  }

  // .display_xs {
  //   margin-left: 0;
  // }
  .xs-mr-tp-5 {
    position: relative;
    left: unset;
    width: 45%;
    ::v-deep {
      .multiselect.multiselect-single-dropdown {
        // margin-left: 0px;
        margin-left: 20px;
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .notification_box {
    left: 43%;
  }
  .search-country {
    padding-right: 15px;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .responsive_wrapper {
    height: 30vh;
  }
  .container1 {
    max-height: 22vh;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .container1 {
    max-height: calc(110vh - 586px);
  }
}
</style>
